import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { autoinject } from "aurelia-framework";
import { AddSubtaskRequest } from "../models/subtasks.models";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";

@autoinject
export class SubtasksApi {

    public platformUrl: string = `${this.configService.config.urls.rightShipPlatformApiUrl}`

    constructor(private requestClientService: RequestClientService, private configService: ConfigService) { }

    //Add subtask
    public addSubtask(request: AddSubtaskRequest): Promise<number> {
        return this.requestClientService.postFormData(`${this.platformUrl}/api/v1/Subtask/AddSubtask`, request);
    }
}